import {ServiceBase} from '../ServiceBase';
import {action, observable, makeObservable, computed} from 'mobx';
import {Check} from '@sparkware/app-utils';
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {ISpinnerService} from "../../../common/interfaces/spinner.service.interface";

export type SPINNER_TYPE = "REGULAR_SPINNER" | "MIGRATION_SPINNER";

interface ActiveSpinnerInfo {
  startTime: number | null;
  spinnerType: SPINNER_TYPE | null;
}

export class SpinnerService extends ServiceBase implements ISpinnerService {
  constructor(services: IServiceFactoryExtended) {
    super(services);

    makeObservable(this);
  }

  @computed
  get isSpinning(): boolean {
    return !Check.isNullOrUndefined(this._activeSpinner?.startTime);
  }

  @computed
  public get isTheRegularSpinnerActive(): boolean {
    return this.activeSpinnerType === "REGULAR_SPINNER";
  }

  @computed
  public get isTheMigrationSpinnerActive(): boolean {
    return this.activeSpinnerType === "MIGRATION_SPINNER";
  }

  @computed
  private get activeSpinnerType(): SPINNER_TYPE | null {
    return this._activeSpinner?.spinnerType || null;
  }

  @observable.ref
  private _activeSpinner: ActiveSpinnerInfo | null = null;

  @action.bound
  startSpinner(isMigrationSpinner?: boolean): void {

    if (this.isSpinning) {
      this.stopSpinner();
    }

    this._activeSpinner = {
      spinnerType: isMigrationSpinner ? "MIGRATION_SPINNER" : "REGULAR_SPINNER",
      startTime: this.services.time.performanceNow()
    };
  }

  @action.bound
  stopSpinner() {
    if(this.isSpinning) {
      this._activeSpinner = null;
    }
  }
}